import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
} from '@mui/material';
import servicio1 from '../../../services/servicio1';

const LigasLanding = () => {
  const [ligas, setLigas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLigas = async () => {
      try {
        const data = await servicio1.traerligas();
        setLigas(data);
      } catch (error) {
        console.error('Error al traer ligas:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLigas();
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #022c43, #05386b)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pt: 4,
        pb: 8,
      }}
    >
      <Typography
        variant="h5"
        sx={{ color: 'white', fontWeight: 'bold', mb: 3 }}
      >
        Ligas Disponibles
      </Typography>

      {loading ? (
        <CircularProgress sx={{ color: 'white', mt: 4 }} />
      ) : ligas.length === 0 ? (
        <Typography sx={{ color: 'white' }}>No hay ligas disponibles.</Typography>
      ) : (
        ligas.map((liga, index) => (
          <Card
            key={index}
            sx={{
              width: '90%',
              maxWidth: 400,
              backgroundColor: 'white',
              borderRadius: 3,
              boxShadow: 6,
              mb: 3,
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.02)',
              },
            }}
          >
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                {liga.nombre}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                {liga.descripcion}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  display: 'inline-block',
                  backgroundColor: '#06437c',
                  color: 'white',
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 2,
                  fontSize: '0.75rem',
                }}
              >
                Zona: {liga.zona}
              </Typography>
            </CardContent>
          </Card>
        ))
      )}
    </Box>
  );
};

export default LigasLanding;
